<div class="mb-3">
    <button (click)="exportStats()" mat-raised-button color="primary">
        <mat-icon class="me-2">download</mat-icon>
        Exporteer naar CSV
    </button>
</div>
<table class="mat-elevation-z1 w-100" [dataSource]="dataSource" mat-table>
    <ng-container matColumnDef="name">
        <th *matHeaderCellDef mat-header-cell>Gebruiker</th>
        <td *matCellDef="let row" mat-cell>{{ row.name }}</td>
    </ng-container>

    <ng-container matColumnDef="answered">
        <th *matHeaderCellDef mat-header-cell>Vragen beantwoord</th>
        <td *matCellDef="let row" mat-cell>{{ row.answered }}</td>
    </ng-container>

    <ng-container matColumnDef="correct">
        <th *matHeaderCellDef mat-header-cell>Goed</th>
        <td *matCellDef="let row" mat-cell>
            {{ row.correct }}
        </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
</table>
